import React from "react";
import desk from "../../../assets/qrcode/desk.png";
import { Card, CardBody } from "reactstrap";

export const SwitchTableCard = ({ table, onClick, isSelected }) => {
  const occupiedStyle = table.isOccupied
    ? "rgba(220, 53, 69, 0.5)" // red overlay
    : "rgba(25, 135, 84, 0.7)"; // green overlay

  return (
    <Card
      className={`mb-3 shadow-sm position-relative border-2 ${
        isSelected ? "border-primary" : "border-light"
      }`}
      onClick={!table.isOccupied ? onClick : undefined}
      style={{ cursor: table.isOccupied ? "not-allowed" : "pointer" }}
    >
      <div className="position-relative rounded-3 shadow-sm overflow-hidden">
        {/* Table image */}
        <img
          src={desk}
          className="card-img-top w-100 object-fit-cover"
          alt="Table"
          style={{ height: "15vh", objectFit: "contain" }}
        />

        {/* Overlay */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background: occupiedStyle,
            transition: "background-color 0.3s ease",
            opacity: 0.55,
          }}
        />

        {/* Text Overlay */}
        <div className="position-absolute top-0 start-0 w-100  p-3 d-flex flex-column justify-content-between">
          {/* Header (Table Name + ID Badge) */}
          <div className="d-flex flex-column  justify-content-between align-items-center align-content-center">
     
              <h6 className="fw-semibold text-white">
                {table.identification}
              </h6>
              <span className="badge bg-light text-dark shadow-sm mb-2">
                #{table.id}
              </span>
                <span
                  className={`badge  rounded-pill shadow-sm ${
                    table.isOccupied ? "bg-danger" : "bg-success"
                  }`}
             
                >
                  {table.isOccupied ? "Occupied" : "Available"}
                </span>
            
          </div>

          {/* Footer (Status Badge) */}
        </div>
      </div>

      <CardBody className="p-2 bg-light rounded-bottom">
        <div className="d-flex justify-content-between align-items-center">
          <small
            className={`fw-semibold ${
              table.isActive ? "text-success" : "text-secondary"
            }`}
          >
            {table.isActive ? "Active" : "Inactive"}
          </small>
          {isSelected && (
           <i class='bx bxs-checkbox-checked fs-5 text-primary'></i>
          )}
        </div>
      </CardBody>
    </Card>
  );
};
